import lazyWithSuspense from 'modules/lazyWithSuspense';
import makePage from 'modules/makePage';
import Page from 'modules/Page';
import * as constants from './constants';

const UserFeedbackAdminPage = lazyWithSuspense(() => import('./UserFeedbackAdminPage'));

const page: Page = {
  title: constants.TITLE,

  routeProps: {
    path: constants.ROUTE_PATH,
  },
  component: makePage({ WrappedPage: UserFeedbackAdminPage, titleFn: () => constants.TITLE }),
};

export default page;
